import React from "react";
import { translate } from "react-i18next";
import mainDC from "../../assets/media/revised/DC_PLC.png";
import mobile from "../../assets/media/revised/daycash_mobile.png";
import scam from "../../assets/media/revised/scam.jpg";

function About({ t, i18n }) {
  const url_lang = i18n.language === "en" ? "/en" : "";

  return (
    <div>
      <div>
        <h2 className="text-center">!!!SCAM ALERT!!!</h2>
        <img width="800" className="center-img" src={scam} alt="" />
      </div>
      <section>
        <div className="container">
          <div className="row">
            <div className="homepage-about-wrapper col-md-6 col-xs-12">
              <img
                className="img-responsive homepage-about-logo"
                src={mainDC}
                alt="DC logo"
              />
              <div>
                <h3 style={{ fontSize: "36px", margin: "0" }}>
                  {t("homepage_about_title")}
                </h3>
                <p className="main-subtitle max400">
                  {t("homepage_about_desc")}
                </p>
              </div>

              <div className="btn-link-wrapper--about">
                <div className="go-daycash-btn">
                  <a
                    className="go-daycash-btn--link"
                    href={`${url_lang}/daycash`}
                  >
                    {t("homepage_about_btn1")}
                    <span className="glyphicon glyphicon-arrow-right"></span>
                  </a>
                </div>
              </div>
              <div className="btn-link-wrapper--about">
                <div className="go-daycash-btn">
                  <a
                    className="go-daycash-btn--link alt"
                    href={`${url_lang}/contact`}
                  >
                    {t("homepage_about_btn2")}
                    <span className="glyphicon glyphicon-arrow-right"></span>
                  </a>
                </div>
              </div>
              <div className="homepage-about-link">
                <a href={`${url_lang}/aboutus`}>{t("homepage_about_link")}</a>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <img className="center-img" src={mobile} alt="DC logo" />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="cashflow-wrapper">
            <p className="main-title lacking">{t("lacking_cashflow1")}</p>
            <p className="main-title lacking">{t("lacking_cashflow2")}</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default translate("translations")(About);



// WEBPACK FOOTER //
// ./src/components/home/About.jsx